import { updateLastLoginTime } from '../../shared/user';
import { setLastAccessedBranch } from '../../shared/branch';
import { MutationSchema } from '../types';

export const userMutations = {
  updateLastLoginTime: (): MutationSchema<any, any> => ({
    mutationKey: ['user', 'updateLastLoginTime'],
    mutationFn: async () => {
      return await updateLastLoginTime();
    }
  }),
  
  setLastAccessedBranch: (): MutationSchema<any, { branchId: string | number; tenantId: number; componentId: number }> => ({
    mutationKey: ['user', 'setLastAccessedBranch'],
    mutationFn: async ({ branchId, tenantId, componentId }) => {
      return await setLastAccessedBranch(branchId, tenantId, componentId);
    }
  })
};
